import { ICogSvcConfigProvider } from 'smarthub-common'
import { CogSvcConfigProvider, ICogSvcConfigProps } from 'smarthub-providers'
import { IProps } from '../props'

export const cogSvc = ({
  botHandle: handle,
  personality,
  serviceUris: { botToken: uri },
}: IProps): ICogSvcConfigProvider => {
  const {version} = uri.match(/api\/v(?<version>\d+)\//).groups ?? {};
  const config: ICogSvcConfigProps = {
    bot: {
      handle,
      version,
      personality,
      cache: {
        storage: 'session',
        ttl: {
          unit: 'min',
          value: 30,
        },
      },
      configSvc: {
        uri,
        serviceUser: 'flex-anon',
      },
    },
  }
  return new CogSvcConfigProvider(config)
}
